import { render, staticRenderFns } from "./ChemicalReagent.vue?vue&type=template&id=0e8057ee&scoped=true"
import script from "./ChemicalReagent.vue?vue&type=script&lang=js"
export * from "./ChemicalReagent.vue?vue&type=script&lang=js"
import style0 from "./ChemicalReagent.vue?vue&type=style&index=0&id=0e8057ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8057ee",
  null
  
)

export default component.exports